<template>
    <v-container class="pt-0">
        <v-row>
            <v-col cols="12" class="pa-0">
                <v-stepper v-model="e1" class="elevation-0">
                    <template>
                        <v-stepper-header class="elevation-0 stepperHeader">
                            <v-divider></v-divider>
                            <v-stepper-step
                                
                                editable
                                step="1"
                                >{{
                                    $t('superAdmin:changeCompanyLogo')
                                }}</v-stepper-step
                            >
                            <v-divider></v-divider>
                        </v-stepper-header>
                        <v-stepper-items>
                            <v-stepper-content step="1">
                                <v-row>
                                    <v-col cols="12" md="12" class="pt-0">
                                        <Separator
                                            :text="
                                                $t(
                                                    'superAdmin:changeCompanyLogo'
                                                )
                                            "
                                        />
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" md="12">
                                        <div class="pa-4 p-relative">
                                            <Cropper
                                                class="cropper"
                                                @change="changeLogo()"
                                                :src="image"
                                                ref="cropper"
                                            />
                                            <div class="cropper__content">
                                                <v-icon
                                                    size="60"
                                                    class="ma-5"
                                                    color="#445D75"
                                                    >mdi-arrow-down-bold-circle</v-icon
                                                >
                                                <p>
                                                    {{
                                                        $t(
                                                            'superAdmin:cropperAction'
                                                        )
                                                    }}
                                                </p>
                                            </div>

                                            <div class="button-wrapper">
                                                <form
                                                    enctype="multipart/form-data"
                                                >
                                                    <span
                                                        class="button img-buttons"
                                                    >
                                                        <input
                                                            type="file"
                                                            @change="
                                                                uploadImage(
                                                                    $event
                                                                )
                                                            "
                                                            ref="file"
                                                            accept="image/*"
                                                            name="image-event"
                                                            id="image-event"
                                                        />
                                                    </span>
                                                </form>
                                            </div>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-stepper-content>
                        </v-stepper-items>
                    </template>
                </v-stepper>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { Cropper, CircleStencil } from 'vue-advanced-cropper'
export default {
    i18nOptions: { namespaces: ['superAdmin'] },
    data() {
        return {
            e1: 1,
            editable: true,
            image: null,
            file_before: '',
        }
    },
    components: {
        Cropper,
        CircleStencil,
    },
    computed: {
        ...mapGetters(['getSettingsErrors']),
    },
    methods: {
        ...mapMutations(['setLogo']),
        changeLogo() {
            const formData = new FormData()
            const { canvas } = this.$refs.cropper.getResult()
            if (canvas) {
                canvas.toBlob(blob => {
                    formData.append('image', blob)
                    this.setLogo({ formData })
                }, 'image/png')
            }
        },
        uploadImage(event) {
            this.file_before = this.$refs.file.files[0]
            let input = event.target
            if (input.files && input.files[0]) {
                let reader = new FileReader()
                reader.onload = e => {
                    this.image = e.target.result
                }
                reader.readAsDataURL(input.files[0])
            }
        },
    },
}
</script>
